var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnRefreshThirdParty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.5C7.58172 5.5 4 9.08172 4 13.5C4 17.9183 7.58172 21.5 12 21.5C16.4183 21.5 20 17.9183 20 13.5C20 11.8554 19.5038 10.3268 18.6528 9.05556",
    stroke: "#373737",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.43457L17.0986 5.5L12.5 8.56543L12.5 2.43457Z",
    fill: "#373737",
    stroke: "#373737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnRefreshThirdParty);
export default __webpack_public_path__ + "static/media/icn_refresh_third_party.c9b052f8d103c558e9c11ba1aff8cfdd.svg";
export { ForwardRef as ReactComponent };